import { createStyles } from '@mantine/core';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';

import { ErrorScreen } from '../ErrorScreen/ErrorScreen';
import { Text } from '../Text/Text';

const useStyles = createStyles((theme) => ({
  outline: {
    color: theme.colors.gray[6],
    borderColor: theme.colors.gray[6],
  },
}));

function NotFoundScreen() {
  const { classes } = useStyles();
  const { t } = useTranslation('common');

  return (
    <ErrorScreen
      errorCode={404}
      title={t('pages.notFound.title')}
      description={
        <Trans
          i18nKey="common:pages.notFound.description"
          components={{
            link: (
              <Link
                className={classes.outline}
                href="mailto:support@splashsports.com?subject=Splash Support - Deposit Issues&body=Hello, Splash Support"
                target="_blank"
              >
                <Text>{t('pages.notFound.action.support')}</Text>
              </Link>
            ),
          }}
        />
      }
    />
  );
}

export default NotFoundScreen;
